import * as mock from "./mock";
import { create } from "../UtilsOld";

const Service = {};
const option = [
    /**
     * 新增
     * @param { JSON } 项目对象
     */
    ["add", "/v1/user/xiangmu", "post", true],
    /**
     * 修改
     * @param { Array } ids 项目标识列表
     */
    ["update", "/v1/user/xiangmu", "put", true],
    /**
     * 删除
     * @param { Array } ids 项目标识列表
     */
    ["delete", "/v1/user/xiangmu", "delete", true],
    /**
     * 审核
     * @param { Array } ids 项目标识列表
     * @param { Number } status 审核状态（2 驳回 3 审核）
     * @param { String } reason 审核原由
     */
    ["audit", "/v1/user/xiangmu/audit", "post", true],
    /**
     * 项目详情
     * @param { Number } chengguoId 项目 ID
     */
    ["detail", "/v1/xiangmu/detail", "get", true],
    /**
     * 项目列表
     * @param { Number } scopeId 领域 ID
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     * @param { Number } sort 排序（1 综合 2 最新 3 最热）
     */
    ["list", "/v1/xiangmu/listByArea", "get", true],
    /**
     * 成果列表
     * @param { Number } scopeId 领域 ID
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     * @param { Number } sort 排序（1 综合 2 最新 3 最热）
     */
    ["auditList", "/v1/xiangmu/audit/list", "get", true],
    /**
     * 项目列表
     * @param { Number } scopeId 领域 ID
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     * @param { Number } sort 排序（1 综合 2 最新 3 最热）
     */
    ["myList", "/v1/user/xiangmu/list", "get", true],
    /**
     * 项目详情
     * @param { Number } chengguoId 项目 ID
     */
    ["projectDetail", "/project/detail", "get", true],
    /**
     * 项目列表
     * @param { Number } scopeId 领域 ID
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     * @param { Number } sort 排序（1 综合 2 最新 3 最热）
     */
    ["projectList", "/v1/xiangmu/listByArea", "get", true],
    /**
     * 项目推荐列表
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     */
    ["recommendList", "/zaicu/recommend/list", "get", true],
]

create(option, Service, mock)

export default {
    Service,
    option
};
